import {
  Component,
  ViewEncapsulation,
  forwardRef,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core"
import {
  NgbDatepickerI18n,
  NgbDateStruct,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap"
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms"

import { CustomDatepickerI18n } from "./custom-datepicker-i18n.service"
import { MyFormatter } from "./my-formater.service"
import { DateFormatUtils } from "@app/cadastro/admin/utils/date-format-utils"

/*----------------------------------------
 Componente: Datepicker
 Resolvendo problemas de layout diferente nos browsers.
 Compartilhado com o FormBuilder.
-----------------------------------------*/
@Component({
  selector: "seb-datepicker",
  templateUrl: "./datepicker.component.html",
  styleUrls: ["./datepicker.component.css"],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: MyFormatter },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true,
    },
  ],
})
export class DatepickerComponent
  implements ControlValueAccessor
{
  @Input() validators: boolean
  @Input() isDisabled: boolean
  @Input() minDate = { year: 1910, month: 1, day: 1 }
  @Input() maxDate: object
  @Input() inputStyle: object
  @Input() tabindex: object
  @Output() touchedChange = new EventEmitter<boolean>();

  model: NgbDateStruct
  startDate: object
  getValue: string
  formControl: FormControl = new FormControl()
  placeHolder: string = ''
  private value: string

  ngOnInit(): void {
    if (this.isDisabled) {
      this.formControl.disable()
    }
  }
  maskConfig = {
    mask: [
      new RegExp("\\d"),
      new RegExp("\\d"),
      "/",
      new RegExp("\\d"),
      new RegExp("\\d"),
      "/",
      new RegExp("\\d"),
      new RegExp("\\d"),
      new RegExp("\\d"),
      new RegExp("\\d"),
    ],
    showMask: false,
    guide: false,
    placeholderChar: "_",
  }

  constructor(public formatDate: DateFormatUtils, private cd: ChangeDetectorRef) {
    formatDate.getCurrentLanguage()
    this.formControl.valueChanges.subscribe((val) => {
      if (val) {
        if (typeof val === "object") {
          val = `${this.minTwoDigits(val.day)}/${this.minTwoDigits(
            val.month
          )}/${val.year}`
          this.propagateChange(val)
        } else if (val.length === 11) {
          val = val.slice(0, -1)
          this.propagateChange(val)
        } else {
          this.propagateChange(val)
        }
      } else {
        this.propagateChange(val)
      }
    })
  }

  ngAfterViewChecked() {
    if (this.formatDate.isBraziliamFormat() !== undefined && !this.placeHolder) {
      this.placeHolder = this.formatDate.isBraziliamFormat() ? 'dd/mm/aaaa' : 'mm/dd/yyyy'
    }
    this.placeHolder
    this.cd.detectChanges()
  }
  
  private propagateChange = (_: any) => {}

  public writeValue(obj: any) {
    this.value = obj
    this.getValue = this.value
    if (this.getValue) {
      const date: any = String(this.getValue).split("/")
      let dateDisplay = new Date()
      if(this.formatDate.isBraziliamFormat()){
         dateDisplay = new Date(date[2],  date[1] - 1, date[0] )
      }else{
         dateDisplay = new Date(date[2],  date[0] - 1, date[1] )
      }
      
      this.formControl.setValue({
        year: dateDisplay.getFullYear(),
        day: dateDisplay.getDate(),
        month: dateDisplay.getMonth() + 1,
        
      })
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn
  }

  public isInvalidForm() {
    return this.formControl.touched && this.formControl.invalid
  }

  private minTwoDigits(n) {
    return (n < 10 ? "0" : "") + n
  }

  public registerOnTouched() {}

  markAsTouched() {
    this.touchedChange.emit(true)
  }
}
